import { IndeterminateCircleLoader } from 'cdk-radial';

export const CustomLoadingOverlay = (): React.JSX.Element => (
  <div className="ag-overlay-loading-center" role="presentation">
    <IndeterminateCircleLoader dataTestId="indeterminate-circle" size="small" />
  </div>
);
